import {
    CO_GET_HEAVEYCOLLI_LISTING,
    CO_GET_HEAVEYCOLLI_LISTING_SUCCESS,
    CO_GET_HEAVEYCOLLI_LISTING_FAILED,
  } from "./actionTypes"
  
  const initialState = {
    error: "",
    loading: false,
    heaveyColli: null,
  }
  
  const coHeaveyColli = (state = initialState, action) => {
    switch (action.type) {
      case CO_GET_HEAVEYCOLLI_LISTING:
        state = {
          ...state,
          loading: true,
          heaveyColli: action.payload,
        }
        break
      case CO_GET_HEAVEYCOLLI_LISTING_SUCCESS:
        state = { ...state, loading: false, heaveyColli: action.payload }
        break
      case CO_GET_HEAVEYCOLLI_LISTING_FAILED:
        state = { ...state, loading: false }
        break
      default:
        state = { ...state }
        break
    }
    return state
  }
  
  export default coHeaveyColli
  